var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "searchTitle"
  }, "Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "searchTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.215,0c11.717,0,21.215,9.798,21.215,21.884,0,5.219-1.771,10.012-4.728,13.773l10.298,10.624-1.775,1.719-10.229-10.418c-3.821,3.829-9.034,6.186-14.782,6.186C9.498,43.769,0,33.971,0,21.884S9.498,0,21.215,0ZM21.215,2.322C10.741,2.322,2.251,11.08,2.251,21.884s8.49,19.562,18.964,19.562,18.964-8.758,18.964-19.562S31.688,2.322,21.215,2.322Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchButton);
export default __webpack_public_path__ + "static/media/search-button.9cad8a5f592ca19b0918d196aea86f0f.svg";
export { ForwardRef as ReactComponent };